import { useCallback, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import '/assets/styles/sections/order-status.scss';

// Context
import { useTranslation } from '/utilities/i18n';

// Services
import orderServices from '/services/order';

const OrderStatus = ({ order: orderProp, className }) => {
	const { t } = useTranslation();
	const [order, setOrder] = useState(orderProp);
	const fetchTimer = useRef(null);

	const checkOrder = useCallback(() => {
		if (orderProp) {
			orderServices
				.getOrder(orderProp.id)
				.then((order) => {
					setOrder(order);
					if (order.status !== 1 && fetchTimer) {
						clearInterval(fetchTimer.current);
					}
				})
				.catch(() => {});
		}
	}, [orderProp]);

	useEffect(() => {
		if (orderProp && orderProp.status === 1) {
			fetchTimer.current = setInterval(checkOrder, 10000);
		}

		return () => {
			if (fetchTimer.current) {
				clearInterval(fetchTimer.current);
			}
		};
	}, [orderProp]);

	useEffect(() => {
		if (orderProp) {
			setOrder(orderProp);
		}
	}, [orderProp]);

	if (!order) {
		return null;
	}

	return (
		<section className={classNames('section', 'order-status', className)}>
			{order.erp_code ? (
				<>
					<strong className="status-title">{t('Sipariş Numarası')}</strong>
					<div className="status-content">{order.erp_code}</div>
					<div className="status-note">
						{t('Self servis siparişlerde lütfen sana verilecek sipariş numarasını takip et.')}
					</div>
				</>
			) : (
				<div className="status-note">
					{t('Siparişin tamamlanıyor, sipariş numaranı birazdan burada göstereceğiz.')}
				</div>
			)}
		</section>
	);
};

export default OrderStatus;
